<template lang="es">
<div class="profile">
    <Navigation></Navigation>

	<Loader :show="loading" type="inline"></Loader>
	
    <Loader :show="saving"></Loader>


    <div class="container add_top_30 add_bottom_30" v-if="!loading">
        <div class="row">
			
            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>

			<div class="col-md-12 col-lg-9" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Datos personales</h2>
                    </div>
                    <div class="row">
                        
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Nombre</label>
                                        <input type="text" class="form-control" placeholder="Nombre" v-model="form.name" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.name']}">
                                        <div class="invalid-feedback">{{validationErrors['data.name']}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Apellido</label>
                                        <input type="text" class="form-control" placeholder="Apellido" v-model="form.lastname" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.lastname']}">
                                        <div class="invalid-feedback">{{validationErrors['data.lastname']}}</div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Documento</label>
                                        <select class="form-control" v-model="form.doc_type" 
                                            @change="validateCI()"
                                            :class="{'is-invalid':validationErrors['data.doc_number']}">
                                            <option value="CI" >CI</option>
                                            <option value="Passport" >Documento</option>
                                        </select>
                                        <div class="invalid-feedback">{{validationErrors['data.doc_type']}}</div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Número</label>
                                        <input type="text" class="form-control" placeholder="N de documento" 
                                            v-model="form.doc_number" 
                                            @keyup="validateCI()"
                                            :class="{'is-invalid':validationErrors['data.doc_number'] }">
                                        <div class="invalid-feedback">{{validationErrors['data.doc_number']}}</div>
                                    </div>
                                </div>

                                <!-- <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input type="email" class="form-control" placeholder="Email" v-model="form.email" disabled>
                                    </div>
                                </div> -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Teléfono</label>
                                        <input type="text" class="form-control" placeholder="Teléfono" v-model="form.phone" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.phone']}">
                                        <div class="invalid-feedback">{{validationErrors['data.phone']}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Fecha de nacimiento</label>
                                        <InputDate :value="form.birthdate" @validated="birthdateChanged" @change="hasChanges=true" ></InputDate>
                                        <div class="invalid-feedback d-block">{{validationErrors['data.birthdate']}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Género</label>
                                        <select class="form-control" v-model="form.gender" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.gender']}" >
                                            <option value="male">Masculino</option>
                                            <option value="female">Femenino</option>
                                        </select>
                                        <div class="invalid-feedback">{{validationErrors['data.gender']}}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>    
                
                    <div class="header_box">
                        <h2><i class="pe-7s-map-marker"></i>Domicilio</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>País</label>
                                <select class="form-control" v-model="form.address_country_id" @change=" hasChanges=true" :class="{'is-invalid':validationErrors['data.address_country_id']}" >
                                    <option v-for="country in countries" :key="country.id" :value="country.id">{{country.name}}</option>
                                </select>
                                <div class="invalid-feedback">{{validationErrors['data.address_country_id']}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="form.address_country_id==226"> 
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Ciudad</label>
                                <select class="form-control" v-model="form.address_region_id" @change="regionChanged(); hasChanges=true" >
                                    <option v-for="region in regions" :key="region.id" :value="region.id">{{region.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Localidad </label>
                                <select class="form-control" v-model="form.address_locality_id" :disabled="loadingLocalities" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.address_locality_id']}">
                                    <option v-for="locality in localities" :key="locality.id" :value="locality.id">{{locality.name}}</option>
                                </select>
                                <small v-if="loadingLocalities">Cargando localidades...</small>
                                <div class="invalid-feedback">{{validationErrors['data.address_locality_id']}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- /row-->
                    <div class="row" v-if="form.address_country_id==226"> 
                        <div class="col">
                            <div class="form-row">
                                <div class="col-8">
                                    <div class="form-group">
                                        <label>Calle</label>
                                        <input type="text" class="form-control" placeholder="Calle" v-model="form.address_street" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.address_street']}">
                                        <div class="invalid-feedback">{{validationErrors['data.address_street']}}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Número</label>
                                        <input type="text" class="form-control" placeholder="Número" v-model="form.address_number" @change="hasChanges=true" :class="{'is-invalid':validationErrors['data.address_number']}">
                                        <div class="invalid-feedback">{{validationErrors['data.address_number']}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Datos adicionales <small>(opcional)</small></label>
                                <input type="text" class="form-control" placeholder="Datos adicionales (Ej: manzana, solar, etc...)" v-model="form.address_comments" @change="hasChanges=true">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col" >
                            <router-link tag="button" class="btn btn-sm pull-left" to="/profile">Volver</router-link>
                            <button class="btn btn-sm pull-right" :class="hasChanges ? 'btn-success' : 'btn-light'"  @click="saveChanges">Guardar cambios</button>
                        </div>
                    </div>
                    <!-- /row-->
                </div>

            </div>

        

        </div>
        
    </div>

    <Footer></Footer>

</div>
</template>

<script>

import gql from 'graphql-tag'
import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
import InputDate from '@/components/InputDate';
import ProfilePicture from '@/components/ProfilePicture';
import ProfileSidebar from '@/components/ProfileSidebar';

export default {
    name: 'Profile',
    metaInfo: {
		title: 'Mi perfil',
	},
    components: {
        Navigation,
        Footer,
        Loader,
        ProfilePicture,
        InputDate,
        ProfileSidebar,
    },
    data() {
        return {
            API_URL: process.env.VUE_APP_API_URL,
            form:{},
            hasChanges:false,
            loading:true,
            saving:false,
            loadingLocalities:false,
            countries:[],
            regions:[],
            localities:[],
            validationErrors:{},
        }
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
    beforeMount(){
        this.loadRegions();
    },
	methods:{
        ...mapMutations(['updateLoggedUserData']),
        birthdateChanged(data){
            this.form.birthdate = this.$moment(data).format('YYYY-MM-DD');
        },
        profilePictureUpdated(profilePicture){
            this.form.picture = profilePicture;
            this.hasChanges = true;
        },
        regionChanged(){
            this.form.address_locality_id = null;
            this.loadLocalities(this.form.address_region_id);
        },
        validateCI(){
            this.hasChanges = true;
            this.validationErrors = {};
            
            if(this.form.doc_type=='CI' && !this.validate_ci(this.form.doc_number)){
                this.validationErrors['data.doc_number'] = "Ingrese una cédula válida";
            }
        },
        validation_digit(ci){
			var a = 0;
			var i = 0;
			if(ci.length <= 6){
				for(i = ci.length; i < 7; i++){
					ci = '0' + ci;
				}
			}
			for(i = 0; i < 7; i++){
				a += (parseInt("2987634"[i]) * parseInt(ci[i])) % 10;
			}
			if(a%10 === 0){
				return 0;
			}else{
				return 10 - a % 10;
			}
		},
		validate_ci(ci){
            if(!ci){return false}
			ci = this.clean_ci(ci);
			var dig = ci[ci.length - 1];
			ci = ci.replace(/[0-9]$/, '');
			return (dig == this.validation_digit(ci));
		},
		random_ci(){
			var ci = Math.floor(Math.random() * 10000000).toString();
			ci = ci.substring(0,7) + this.validation_digit(ci);
			return ci;
		},
		clean_ci(ci){
			return ci.replace(/\D/g, '');
		},
        loadRegions(){
            this.$apollo.query({
				query: gql`query getLocalities($count: Int!) {
					regions(count: $count){
						data{
                            id
                            name
                        }
					}
                    countries{
						id
						name
					}
                }`,
                variables: {
					count: 100,
                },
			})
			.then((data) => {
				this.regions = data.data.regions.data;
				this.countries = data.data.countries;
			});
        },
        loadLocalities(regionId){
            this.localities = [];
            this.loadingLocalities= true;
            this.$apollo.query({
				query: gql`query getLocalities($count: Int!, $regionId: ID!) {
					localities(count: $count, regionId: $regionId) {
                        data{
                            id
                            name
                        }
					}
				}`,
				variables: {
                    count: 100,
					regionId: regionId,
                },
			})
			.then((data) => {
                this.localities = data.data.localities.data;
                this.loadingLocalities= false;
			});
        },
        saveChanges(){
            this.saving=true;
            this.validationErrors = {};

            var dataInput = {		
				name: this.form.name,			
				lastname: this.form.lastname,			
				phone: this.form.phone,			
				birthdate: this.form.birthdate,			
                gender: this.form.gender,
                doc_type: this.form.doc_type,
                doc_number: this.form.doc_number,

                address_country_id: this.form.address_country_id,			
                address_locality_id: this.form.address_locality_id,			
				address_street: this.form.address_street,			
				address_number: this.form.address_number,			
				address_comments: this.form.address_comments,			
			};
			
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:UserUpdateProfileInput! ){
					userUpdateProfile( data: $data) {
						id
                        email
                        fullname
                        gender
                        is_completed
                        picture{
                            id
                            filename
                            url
                            urlThumb
                            type
                            size
                        }
					}
				}`,
				variables: {
					data: dataInput,
				}
			})
			.then((data) => {
				this.$toast.success('Cambios guardados');
                this.saving=false;
                this.hasChanges=false;
                //actualizo la data del usuario en el localstorage
                this.updateLoggedUserData( {loggedUser: data.data.userUpdateProfile})
            })
            .catch(error => {
                this.$toast.error('Rellene todos los campos!');
                let { graphQLErrors } = error;
                if (graphQLErrors[0].extensions.category === "validation") {
                    this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                }else{
                    this.validationErrors['general'] = 'Se ha producido un error';
                }
                this.saving=false;
            })
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
        },
    },
    apollo: {
        me: {
            query: gql`query{
                me {
                    id
                    name
                    lastname
                    phone
                    email
                    doc_type
                    doc_number
                    birthdate
                    gender
                    picture{
                        id
                        filename
                        urlThumb
                    }
                    address_country_id
                    address_locality_id
                    address_street
                    address_number
                    address_comments
                    address_locality{
                        region{
                            id
                        }
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            result (data) {
                this.form = data.data.me;
                if(this.form.address_locality){
                    this.form.address_region_id = this.form.address_locality.region.id;	
                    this.loadLocalities(this.form.address_region_id);
                }
                this.loading=false;
            },
        }
    },
    beforeRouteLeave (to, from , next) {
        if(this.hasChanges ){
            const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios sin guardar!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next()
        }
    }
}
</script>

<style scoped>

</style>
